import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { debounce } from './common/debounce';
import { IdleDetectionService } from './common/services/idle-detection.service';
import { environment } from '../environments/environment';
import { ComponentMessagingService } from './common/services/component-messaging.service';
import { AuthService } from './areas/user/auth/providers/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})

export class AppComponent implements OnInit, OnDestroy {

    constructor(
        private authService: AuthService,
        private idleDetectionService: IdleDetectionService,
        private componentMessagingService: ComponentMessagingService) { }

    @HostListener('mousemove', ['$event'])
    @debounce(environment.idleDetectorDebounceTimeInMs)
    mousemoveHostListener() {
        if (this.authService.isAuthTokenValid()) {
            this.idleDetectionService.setLastActivityTimestamp();
        }
    }

    @HostListener('window:mousewheel', ['$event'])
    @debounce(environment.idleDetectorDebounceTimeInMs)
    mousewheelHostListener() {
        if (this.authService.isAuthTokenValid()) {
            this.idleDetectionService.setLastActivityTimestamp();
        }
    }

    @HostListener('click', ['$event'])
    @debounce(environment.idleDetectorDebounceTimeInMs)
    clickHostListener() {
        if (this.authService.isAuthTokenValid()) {
            this.idleDetectionService.setLastActivityTimestamp();
        }
    }

    @HostListener('window:keyup', ['$event'])
    @debounce(environment.idleDetectorDebounceTimeInMs)
    scrollHostListener() {
        if (this.authService.isAuthTokenValid()) {
            this.idleDetectionService.setLastActivityTimestamp();
        }
    }

    ngOnInit() {
        this.idleDetectionService.setLastActivityTimestamp();
        this.idleDetectionService.watchIdle();

        this.componentMessagingService.getMessage().subscribe((message) => {
            if (message.text === 'login') {
                this.idleDetectionService.setLastActivityTimestamp();
                this.idleDetectionService.watchIdle();
            } else if(message.text === 'logout') {
                this.idleDetectionService.clearIdleDetectionInterval();
                this.idleDetectionService.clearLastActivityTimestamp();
            }
        });
    }

    ngOnDestroy(): void {
        this.idleDetectionService.clearIdleDetectionInterval();
        this.idleDetectionService.clearLastActivityTimestamp();
    }
}
